<template>
  <div
    id="content"
    class="ui bottom attached segment pushable dimmable"
    :class="{ dimmed: globalSearchShowing }"
    v-shortkey="{
      globalSearchToggle: ['ctrl', 'g'],
      save1: ['ctrl', 's'],
      save2: ['ctrl', 'enter'],
      save3: ['meta', 's'],
      save4: ['meta', 'enter']
    }"
    @shortkey="handleShortKey"
  >
    <transition
      enter-active-class="animate__animated animate__slideInLeft"
      leave-active-class="animate__animated animate__slideOutLeft"
      mode="out-in"
    >
      <app-menu class="app-menu" v-if="notOnLoginScreen"></app-menu>
    </transition>
    <main class="ui pusher">
      <transition
        enter-active-class="animate__animated animate__fadeInRight"
        leave-active-class="animate__animated animate__fadeOutRight"
        mode="out-in"
      >
        <router-view class="routerView"></router-view>
      </transition>
    </main>
    <portal-target name="modals"></portal-target>
    <input
      type="text"
      ref="focusInput"
      style="position: absolute; left: -1000px"
      v-model="tempSearchTerm"
      tabindex="-1"
    />
    <global-search
      v-if="notOnLoginScreen && globalSearchShowing"
      @done="globalSearchShowing = false"
      :tempSearchTerm="tempSearchTerm"
    />
    <shortcut-modal v-if="notOnLoginScreen" />
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import './scss/variables';

#content.ui.pushable {
  margin-bottom: 0px;
  border-radius: 0px;
}

.app-menu {
  --animate-duration: 0.2s;
}

main {
  height: 100%;
  .routerView {
    height: 100%;
    padding: 10px 20px 5px 220px;
    --animate-duration: 0.2s;
  }
}
</style>

<script>
// @flow
import { AppMenu, GlobalSearch, ShortcutModal } from './components/UI'
import { mapMutations } from 'vuex'
import { about } from 'utility'
import { Auth } from 'services'
import { runPortPoller } from 'services/PortPoller'
import { MutationTypes } from 'store'

export default {
  name: 'app',
  components: { ShortcutModal, AppMenu, GlobalSearch },
  data() {
    return {
      globalSearchShowing: false,
      // Add a variable for holding search text typed before the search dialog has time to appear and take focus
      tempSearchTerm: ''
    }
  },
  methods: {
    ...mapMutations('config', ['setConfig']),
    handleShortKey(event) {
      if (event.srcKey === 'globalSearchToggle') {
        this.tempSearchTerm = ''
        // Remove focus immediately from wherever it used to be and put it in the focusInput
        if (!this.globalSearchShowing && this.$refs.focusInput) this.$refs.focusInput.focus()
        this.globalSearchShowing = this.notOnLoginScreen && !this.globalSearchShowing
      } else if (event.srcKey && event.srcKey.startsWith('save')) {
        this.$store.commit(MutationTypes.REQUEST_SAVE)
      }
    }
  },
  computed: {
    notOnLoginScreen() {
      return this.$route.path !== '/login'
    }
  },
  mounted() {
    runPortPoller(this.$store)
    setTimeout(() => {
      // Authorize use of default preferences, if none have been loaded after a while
      this.$store.commit(MutationTypes.ALLOW_DEFAULT_PREF_USE)
    }, 3000)
    about()
      .then(k => {
        this.setConfig({ config: k })
        return k
      })
      .catch(e => console.debug('about request failed', e))

    if (Auth.isUserLoggedIn()) {
      this.$ability.update(Auth.extractRulesFromToken(Auth.getToken()))
      this.$store.commit(MutationTypes.USER_AUTHENTICATED, Auth.getLoggedInUser())
    }
  }
}
</script>
